var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login" },
    [
      _vm.showSnackbar
        ? _c("Snackbar", {
            attrs: {
              snackbarColor: _vm.snackbarColor,
              snackbarMessage: _vm.snackbarMessage
            },
            on: {
              close: function($event) {
                return _vm.closeSnackbar()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("v-app", { staticClass: "login-page-container" }, [
        _c("div", { staticClass: "logo-brand" }, [
          _c("img", {
            staticClass: "logo",
            attrs: {
              src: require("../../../common/assets/images/logo-brand.svg"),
              alt: "4IQ Logo"
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "section",
          [
            _c(
              "v-dialog",
              {
                staticClass: "show-info-popup",
                attrs: { width: "700", persistent: "" },
                model: {
                  value: _vm.concurrent_dialog_box,
                  callback: function($$v) {
                    _vm.concurrent_dialog_box = $$v
                  },
                  expression: "concurrent_dialog_box"
                }
              },
              [
                _c(
                  "v-card",
                  [
                    _c(
                      "v-toolbar",
                      {
                        attrs: { flat: "", dense: "", color: "red", dark: "" }
                      },
                      [
                        _c("v-icon", [_vm._v("warning")]),
                        _vm._v(" "),
                        _c("v-toolbar-title", [
                          _vm._v("Concurrent sessions detected")
                        ]),
                        _vm._v(" "),
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-icon",
                          {
                            class: _vm.disable_logout ? "disabled" : "",
                            attrs: { flat: "" },
                            on: {
                              click: function($event) {
                                return _vm.concurrent_session_action("clear")
                              }
                            }
                          },
                          [_vm._v("clear")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-card-text", [
                      _vm._v(
                        "\n                        You already have an active session from "
                      ),
                      _c("b", [
                        _vm._v(" " + _vm._s(_vm.concurrent_session_ip) + " ")
                      ]),
                      _vm._v(
                        " ip . click on proceed below to continue with this login and logout \n                        from all other active sessions automatically.\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c("v-divider", { staticClass: "ma-0" }),
                    _vm._v(" "),
                    _c(
                      "v-card-actions",
                      [
                        _c("v-spacer"),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              id: "proceed-btn",
                              color: "red",
                              flat: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.concurrent_session_action("proceed")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                        proceed\n                        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.showTenantTncPopup
          ? _c(
              "section",
              { staticClass: "tenantTncSection__container" },
              [
                _c("tenantTnc", {
                  attrs: { session: _vm.session, isEndUser: _vm.isEndUser },
                  on: {
                    getTenantTncActions: function($event) {
                      return _vm.tenantTncActions($event)
                    }
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.showTnCView
        ? _c("app-terms", {
            attrs: {
              app: _vm.appDetails.app_name == "ep" ? "ep" : "",
              session: _vm.session
            }
          })
        : _c(
            "div",
            { class: _vm.configureOTP ? "qrCodeSectionEnabled" : "loginpage" },
            [
              _vm.resetToken
                ? _c("div", { staticClass: "logindiv smalldiv" }, [
                    _c(
                      "div",
                      {
                        staticClass: "login-div resetPassword-div",
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            attrs: { id: "loginScreenSetPassword" },
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                              }
                            }
                          },
                          [
                            _c(
                              "v-form",
                              {
                                staticClass: "reset-password-form",
                                model: {
                                  value: _vm.validForm,
                                  callback: function($$v) {
                                    _vm.validForm = $$v
                                  },
                                  expression: "validForm"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "loginpage-logo forgotpage-title"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "forgot-password-form-title"
                                      },
                                      [
                                        _c("p", [
                                          _vm._v("Set your New Password")
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "login-page-subtitle" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            "Both passwords need to be the same."
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "login-content resetpage-content"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-fields" },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            id: "newpassword",
                                            clearable: "",
                                            dark: "",
                                            color: "#EFEFEF",
                                            "append-icon": _vm.viewPassword
                                              ? "visibility"
                                              : "visibility_off",
                                            label: "New password",
                                            type: _vm.viewPassword
                                              ? "text"
                                              : "password",
                                            rules: [
                                              _vm.rules.min,
                                              _vm.rules.strongPassword
                                            ]
                                          },
                                          on: {
                                            "click:append": function($event) {
                                              _vm.viewPassword = !_vm.viewPassword
                                            }
                                          },
                                          model: {
                                            value: _vm.newPassword,
                                            callback: function($$v) {
                                              _vm.newPassword = $$v
                                            },
                                            expression: "newPassword"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-fields" },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            id: "cnewpassword",
                                            clearable: "",
                                            dark: "",
                                            color: "#EFEFEF",
                                            "append-icon": _vm.viewconfirmPassword
                                              ? "visibility"
                                              : "visibility_off",
                                            label: "Confirm password",
                                            type: _vm.viewconfirmPassword
                                              ? "text"
                                              : "password",
                                            rules: [
                                              _vm.rules.min,
                                              _vm.rules.np_cnp_match
                                            ]
                                          },
                                          on: {
                                            "click:append": function($event) {
                                              _vm.viewconfirmPassword = !_vm.viewconfirmPassword
                                            }
                                          },
                                          model: {
                                            value: _vm.cNewPassword,
                                            callback: function($$v) {
                                              _vm.cNewPassword = $$v
                                            },
                                            expression: "cNewPassword"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("p", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.showErrorMessage,
                                          expression: "showErrorMessage"
                                        }
                                      ],
                                      staticClass: "login-error-msg",
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.errorMessageDetails
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-element form-button"
                                      },
                                      [
                                        _vm.fromWelcomeEmail
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "w3-btn w3-block reset-password signin-btn",
                                                attrs: {
                                                  type: "submit",
                                                  disabled: !_vm.validForm
                                                },
                                                on: { click: _vm.setPassword }
                                              },
                                              [_vm._v("Set Password")]
                                            )
                                          : _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "w3-btn w3-block reset-password signin-btn",
                                                attrs: {
                                                  type: "submit",
                                                  disabled: !_vm.validForm
                                                },
                                                on: { click: _vm.setPassword }
                                              },
                                              [_vm._v("Reset Password")]
                                            )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    !_vm.fromWelcomeEmail
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form-element loginpage-links"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                on: { click: _vm.backtoLogin }
                                              },
                                              [_vm._v("Go back to Login Page")]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "confirmationDialog",
                    {
                      attrs: {
                        dialogStatus: _vm.configureOTP,
                        title: "Set Up 2FA",
                        eventName: "qrCodeEvent",
                        actions: _vm.actionsList
                      },
                      on: { qrCodeEvent: _vm.qrCodeActions }
                    },
                    [
                      _c("div", { staticClass: "qrcode__container" }, [
                        _c("div", [
                          _c("p", [
                            _vm._v(
                              "You will need a 2FA method for security. Please download and install any authenticator app on your phone. If it is already installed, you can skip this screen!"
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "1.Download and install an app (such as Google Authenticator) on your mobile."
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "2. Open the authenticator and scan the QR code."
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "qr-code",
                        domProps: { innerHTML: _vm._s(_vm.htmlCode) }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "qrcode-textfield" },
                        [
                          _c("p", [
                            _vm._v(
                              "3. Enter the 6-digit verification code generated."
                            )
                          ]),
                          _vm._v(" "),
                          _c("label", { attrs: { color: "#434446" } }, [
                            _vm._v("Factor authentication code")
                          ]),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              id: "otpInput",
                              placeholder: "Enter 2-factor authentication code",
                              solo: "",
                              flat: "",
                              "background-color": "#F7F7F7",
                              color: "#E34E25",
                              "append-icon": "help_outline"
                            },
                            on: {
                              "click:append": function($event) {
                                return _vm.openHelpDoc()
                              }
                            },
                            model: {
                              value: _vm.otpCode,
                              callback: function($$v) {
                                _vm.otpCode = $$v
                              },
                              expression: "otpCode"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              !_vm.resetToken &&
              !_vm.configureOTP &&
              !_vm.showTenantTncPopup &&
              !_vm.displayAccountpage
                ? _c("div", { staticClass: "logindiv smalldiv" }, [
                    !_vm.showForgotpage &&
                    !_vm.showOTPForm &&
                    !_vm.enableExpirationPage
                      ? _c(
                          "div",
                          {
                            staticClass: "card login-div loginpage-div",
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                              }
                            }
                          },
                          [
                            _c("v-form", { staticClass: "loginform" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "login-page-title login__title-text"
                                },
                                [_c("p", [_vm._v("Login to your Account")])]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "login-content" }, [
                                _c(
                                  "div",
                                  { staticClass: "input-fields multi-input" },
                                  [
                                    _c("v-text-field", {
                                      class: _vm.showLoginMessage
                                        ? "v-input--is-focused"
                                        : "theme-dark",
                                      attrs: {
                                        id: "email",
                                        error: _vm.showLoginMessage
                                          ? true
                                          : false,
                                        label: "Username",
                                        clearable: "",
                                        dark: "",
                                        color: "#EFEFEF",
                                        height: "30"
                                      },
                                      model: {
                                        value: _vm.email,
                                        callback: function($$v) {
                                          _vm.email = $$v
                                        },
                                        expression: "email"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "input-fields" },
                                  [
                                    _c("v-text-field", {
                                      class: _vm.showLoginMessage
                                        ? "v-input--is-focused"
                                        : "theme-dark",
                                      attrs: {
                                        id: "password",
                                        error: _vm.showLoginMessage
                                          ? true
                                          : false,
                                        "append-icon": _vm.viewPassword
                                          ? "visibility"
                                          : "visibility_off",
                                        label: "Password",
                                        type: _vm.viewPassword
                                          ? "text"
                                          : "password",
                                        dark: "",
                                        color: "#EFEFEF"
                                      },
                                      on: {
                                        "click:append": function($event) {
                                          _vm.viewPassword = !_vm.viewPassword
                                        }
                                      },
                                      model: {
                                        value: _vm.password,
                                        callback: function($$v) {
                                          _vm.password = $$v
                                        },
                                        expression: "password"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showLoginMessage,
                                      expression: "showLoginMessage"
                                    }
                                  ],
                                  staticClass:
                                    "small red--text text--lighten-1",
                                  domProps: {
                                    textContent: _vm._s(_vm.loginErrorMessages)
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex form-element loginpage-links"
                                  },
                                  [
                                    _c("v-checkbox", {
                                      staticClass: "mt-0 pt-0",
                                      attrs: {
                                        color: "#e34d25",
                                        label: "Remember me",
                                        id: "rememberMeCheckBox",
                                        "hide-details": ""
                                      },
                                      model: {
                                        value: _vm.rememberMe,
                                        callback: function($$v) {
                                          _vm.rememberMe = $$v
                                        },
                                        expression: "rememberMe"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("v-spacer"),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "text-xs-right",
                                        attrs: { id: "forgotPasswordPage" },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleForgotPasswordClick()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Forgot Password?\n                            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-element form-button signin-button-container"
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "w3-btn w3-block signin-btn",
                                        attrs: {
                                          type: "submit",
                                          id: "signInBtn"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.login()
                                          }
                                        }
                                      },
                                      [_vm._v("Sign In")]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.enable_sso
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-element login-seperator"
                                      },
                                      [
                                        _c("hr", {
                                          staticClass: "sso-signin-seperator"
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("OR")]),
                                        _vm._v(" "),
                                        _c("hr", {
                                          staticClass: "sso-signin-seperator"
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.enable_sso
                                  ? _c("div", { staticClass: "form-element" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "w3-btn w3-block signin-btn sso-button",
                                          attrs: {
                                            type: "submit",
                                            id: "signInBtn"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.ssoLogin()
                                            }
                                          }
                                        },
                                        [_vm._v("Sign in with single sign-on")]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex form-element login__account-page-actions"
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          id: "backToAccountIcon",
                                          color: "#ffffff",
                                          dense: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.backtoAccountPage()
                                          }
                                        }
                                      },
                                      [_vm._v("icon-arrow_left")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-xs-left back-to-accountpage",
                                        on: {
                                          click: function($event) {
                                            return _vm.backtoAccountPage()
                                          }
                                        }
                                      },
                                      [_vm._v("Back to Account")]
                                    ),
                                    _vm._v(" "),
                                    _c("v-spacer"),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-xs-right login__account-page-link"
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "mailto:support@constellaintelligence.com?subject=Constella IDHunt Core Support",
                                              target: "new"
                                            }
                                          },
                                          [_vm._v("Contact Constella Support")]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {}, [
                      _vm.showForgotpage
                        ? _c("div", { staticClass: "forgotpage-main-div" }, [
                            _c(
                              "div",
                              { staticClass: "login-div forgotpass-div" },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: {
                                      id: "loginScreenRecoveryPassword"
                                    },
                                    on: {
                                      submit: function($event) {
                                        $event.preventDefault()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-form",
                                      {
                                        staticClass: "forgot-password-form",
                                        on: {
                                          submit: function($event) {
                                            $event.preventDefault()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "loginpage-logo forgotpage-title"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "forgot-password-form-title"
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v("Recovery Password")
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "login-page-subtitle"
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    "We will send you a link to reset your password."
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "login-content forgotpage-content"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "input-fields multi-input"
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    id: "forgotEmail",
                                                    label: "Username",
                                                    disabled: "",
                                                    dark: "",
                                                    color: "#EFEFEF"
                                                  },
                                                  model: {
                                                    value: _vm.email,
                                                    callback: function($$v) {
                                                      _vm.email = $$v
                                                    },
                                                    expression: "email"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "input-fields" },
                                              [
                                                _c("v-text-field", {
                                                  staticClass:
                                                    "input-in-right-panel",
                                                  attrs: {
                                                    id: "forgotTenantid",
                                                    label: "Account",
                                                    dark: "",
                                                    color: "#EFEFEF",
                                                    disabled: ""
                                                  },
                                                  model: {
                                                    value: _vm.tenantID,
                                                    callback: function($$v) {
                                                      _vm.tenantID = $$v
                                                    },
                                                    expression: "tenantID"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("vue-recaptcha", {
                                              ref: "recaptcha",
                                              staticClass: "vueRecaptcha",
                                              attrs: {
                                                id: "recaptcha",
                                                sitekey: _vm.captchaSiteKey
                                              },
                                              on: {
                                                verify: _vm.onCaptchaVerified,
                                                expired: _vm.onCaptchaExpired
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-element form-button"
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "w3-btn w3-block signin-btn",
                                                    class: !_vm.storeCaptchaToken
                                                      ? "disabledOn"
                                                      : "",
                                                    attrs: {
                                                      type: "submit",
                                                      id: "sendLinkBtn"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.sendMail()
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Send Link")]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex form-element login__account-page-actions"
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      id: "backToAccountIcon",
                                                      color: "#ffffff",
                                                      dense: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.backtoLoginPage()
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("icon-arrow_left")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-xs-left back-to-accountpage",
                                                    staticStyle: {
                                                      color: "white"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.backtoLoginPage()
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Back to Login")]
                                                ),
                                                _vm._v(" "),
                                                _c("v-spacer"),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-xs-right login__account-page-link"
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href:
                                                            "mailto:support@constellaintelligence.com?subject=Constella IDHunt Core Support",
                                                          target: "new"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Contact Constella Support"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showOTPForm
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "login-div forgotpass-div code-validation-form"
                            },
                            [
                              _c(
                                "v-form",
                                {
                                  staticClass: "forgot-password-form",
                                  on: {
                                    submit: function($event) {
                                      $event.preventDefault()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "login-page-title" },
                                    [
                                      _c("p", [
                                        _vm._v("2FA Authentication code")
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "login-content forgotpage-content"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-fields" },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "input-in-right-panel",
                                            attrs: {
                                              id: "otpInput",
                                              "append-icon": "help_outline",
                                              label: "CODE",
                                              dark: "",
                                              color: "#EFEFEF"
                                            },
                                            on: {
                                              "click:append": function($event) {
                                                return _vm.openHelpDoc()
                                              }
                                            },
                                            model: {
                                              value: _vm.otpCode,
                                              callback: function($$v) {
                                                _vm.otpCode = $$v
                                              },
                                              expression: "otpCode"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.enableTimer
                                        ? _c("countDown", {
                                            attrs: {
                                              text:
                                                "2FA attempts exceeded, Please wait for",
                                              secondsTime: _vm.secondsTimer,
                                              timerDisplayStatus:
                                                _vm.enableTimer
                                            },
                                            on: {
                                              timerCompleted: _vm.stopTimer
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-element loginpage-links inner-addon left-addon right-addon"
                                        },
                                        [
                                          _c("v-checkbox", {
                                            staticClass: "mt-0 pt-0",
                                            attrs: {
                                              color: "#EFEFEF",
                                              label: "Remember me for 30 Days",
                                              "hide-details": ""
                                            },
                                            model: {
                                              value: _vm.remember,
                                              callback: function($$v) {
                                                _vm.remember = $$v
                                              },
                                              expression: "remember"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-element form-button"
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "w3-btn w3-block signin-btn",
                                              attrs: {
                                                type: "submit",
                                                id: "validateCode",
                                                disabled: _vm.enableTimer
                                              },
                                              on: { click: _vm.validateCode }
                                            },
                                            [_vm._v("Validate Code")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.enableExpirationPage
                      ? _c("div", { staticClass: "forgotpage-main-div" }, [
                          _c(
                            "div",
                            { staticClass: "login-div forgotpass-div" },
                            [
                              _c(
                                "v-form",
                                {
                                  staticClass: "forgot-password-form",
                                  on: {
                                    submit: function($event) {
                                      $event.preventDefault()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "loginpage-logo forgotpage-title"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "password-expiration-title mb-6"
                                        },
                                        [_c("p", [_vm._v("NEW PASSWORD")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "password-expiration-subtitle"
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              "Your password has expired after " +
                                                _vm._s(_vm.totalExpiredDaya) +
                                                " days in accordance with your \n                                        Organization policies. Please, set up a new password."
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "login-content forgotpage-content expiredPage"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-fields" },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              id: "oldexpiredAccPwd",
                                              type: "password",
                                              label: "Old password",
                                              dark: "",
                                              color: "#EFEFEF",
                                              error:
                                                _vm.expiredOldPasswordErrorIndicator
                                            },
                                            model: {
                                              value: _vm.expiredPassword,
                                              callback: function($$v) {
                                                _vm.expiredPassword = $$v
                                              },
                                              expression: "expiredPassword"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-fields" },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              id: "expiredAccPwd",
                                              type: "password",
                                              label: "Set new password",
                                              dark: "",
                                              color: "#EFEFEF",
                                              error: _vm.showExpirationError
                                            },
                                            model: {
                                              value: _vm.expiredAccountPassword,
                                              callback: function($$v) {
                                                _vm.expiredAccountPassword = $$v
                                              },
                                              expression:
                                                "expiredAccountPassword"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-fields" },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "input-in-right-panel",
                                            attrs: {
                                              id: "newexpiredPwd",
                                              type: "password",
                                              label: "Reset your new password",
                                              dark: "",
                                              color: "#EFEFEF",
                                              error: _vm.showExpirationError
                                            },
                                            model: {
                                              value:
                                                _vm.resetExpiredAccountPassword,
                                              callback: function($$v) {
                                                _vm.resetExpiredAccountPassword = $$v
                                              },
                                              expression:
                                                "resetExpiredAccountPassword"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "passwordExpirationError",
                                          class:
                                            _vm.showExpirationError ||
                                            _vm.showSuccessMessage ||
                                            _vm.expiredOldPasswordErrorIndicator
                                              ? "displayError"
                                              : "hideError"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.expirationErrorMessage)
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-element form-button"
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "w3-btn w3-block signin-btn",
                                              attrs: {
                                                type: "submit",
                                                id: "sendLinkBtn"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.expirationLogin()
                                                }
                                              }
                                            },
                                            [_vm._v("Login")]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.displayAccountpage
                ? _c("div", { staticClass: "logindiv accountPageView" }, [
                    !_vm.showForgotpage &&
                    !_vm.showOTPForm &&
                    !_vm.enableExpirationPage &&
                    !_vm.resetToken
                      ? _c(
                          "div",
                          {
                            staticClass: "card login-div loginpage-div",
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                              }
                            }
                          },
                          [
                            _c("v-form", { staticClass: "loginform" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "login-page-title login__title-text"
                                },
                                [_c("p", [_vm._v("Login to your Account")])]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "logo-message" },
                                [
                                  _c("v-text-field", {
                                    staticClass: "account-text",
                                    attrs: {
                                      id: "tenantid",
                                      dark: "",
                                      color: "#ffffff",
                                      clearable: true,
                                      autofocus: true,
                                      error: _vm.showStatusMessage
                                        ? true
                                        : false,
                                      label: "Account",
                                      "hide-details": ""
                                    },
                                    model: {
                                      value: _vm.tenantID,
                                      callback: function($$v) {
                                        _vm.tenantID = $$v
                                      },
                                      expression: "tenantID"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.showStatusMessage
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "login__account-page-actions status-message"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "login__account-status-message"
                                        },
                                        [_vm._v(_vm._s(_vm.statusMessageText))]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "login__account-page-actions" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "w3-btn w3-block signin-btn",
                                      class: _vm.showStatusMessage
                                        ? "nextDisabled"
                                        : "",
                                      attrs: {
                                        type: "submit",
                                        id: "signInBtn"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.enableSSOButton()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "Next  \n                            "
                                      ),
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("icon-arrow_right")
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "login__account-page-actions" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "login__account-page-link" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              "mailto:support@constellaintelligence.com?subject=Constella IDHunt Core Support",
                                            target: "new"
                                          }
                                        },
                                        [_vm._v("Contact Constella Support")]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ]
          ),
      _vm._v(" "),
      _vm.showProgressBar
        ? _c("div", { staticClass: "logindiv smalldiv" }, [
            _c("div", { staticClass: "login-div progressBar-div" }, [
              _c("p", { staticClass: "text-xs-center display-1" }, [
                _vm._v("WELL DONE")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "container" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pt-3" },
                  [
                    _c("v-progress-linear", {
                      attrs: {
                        color: "cyan accent-4",
                        indeterminate: "",
                        rounded: "",
                        height: "6"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showBackupCodesPopup
        ? _c("backupCodesModal", {
            attrs: {
              fromHeader: false,
              regenerate: _vm.regenerate,
              dialogStatus: _vm.showBackupCodesPopup
            },
            on: {
              close: function($event) {
                _vm.showBackupCodesPopup = false
                _vm.showTenantTnc()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loginpage-logo" }, [
      _c("img", {
        staticClass: "logo",
        attrs: {
          src: require("../../../common/assets/images/Logo_4iQ-DEEP_with_R_MAIN.svg"),
          alt: "4IQ Logo"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }